import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/atelier.css';
import './styles/reset.css';
import './styles/spatial.css';

// Belt-and-suspenders: surface any render/hook/module error directly into the
// DOM so we can see what's wrong without opening devtools. Visible text on
// white; no silent blank screen.
function showFatal(where: string, e: unknown) {
  const root = document.getElementById('root');
  if (!root) return;
  const stack = (e as { stack?: string })?.stack ?? String(e);

  const wrap = document.createElement('div');
  wrap.style.cssText = "font-family:'Geist Mono',ui-monospace,monospace;padding:32px;max-width:960px;";

  const label = document.createElement('div');
  label.style.cssText = 'font-size:10px;letter-spacing:.1em;color:#B91C1C;margin-bottom:12px';
  label.textContent = `MISSION CONTROL — BOOT ERROR (${where})`;

  const pre = document.createElement('pre');
  pre.style.cssText = 'white-space:pre-wrap;word-break:break-word;font-size:12px;line-height:1.55;color:#0A0A0A;background:#F6F6F4;padding:16px;border:1px solid #E8E8E6;border-radius:2px;';
  pre.textContent = stack;

  wrap.appendChild(label);
  wrap.appendChild(pre);
  root.innerHTML = '';
  root.appendChild(wrap);
}

window.addEventListener('error', (e) => showFatal('window.error', e.error ?? e.message));
window.addEventListener('unhandledrejection', (e) => showFatal('unhandledrejection', e.reason));

(async () => {
  try {
    const { App } = await import('./App');
    // Intentionally NOT wrapping in React.StrictMode.
    // Supabase Realtime channels reject adding postgres_changes callbacks
    // after subscribe() — StrictMode's double-invocation of effects triggered
    // that exact error and blanked the page. We re-evaluate once the hooks
    // are hardened against double-invocation.
    ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
  } catch (e) {
    showFatal('bootstrap', e);
  }
})();
